import { AUTH_SOURCE } from '@core/constant/constant';
import { AuthToken } from '@core/interface/common/auth-token';
import { EntraLoginBody, LoginBody } from '@core/models/api/auth.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { response } from 'express';

export const AuthActions = createActionGroup({
  source: AUTH_SOURCE,
  events: {
    'Login': props<{ body: LoginBody }>(),
    'Entra Login': props<{ body: EntraLoginBody }>(),
    'Login Success': (userName: string, response: AuthToken) => ({userName, response}),
    'Redirect After Login':  emptyProps(),
    'Logout': emptyProps(),
    'RefreshToken': emptyProps(),
    'RefreshToken Success': (response: AuthToken) => ({response}),
    'Load Permissions': emptyProps(),
    'Load Permissions Success': (permissions: string[]) => ({permissions}),
    'Load Permissions Failure': emptyProps()
  },
});
